import { useSearchParams } from 'react-router-dom';
import type { RezaParamsMutable } from '@gov-nx/core/hooks';

export const useRezaSearchParams = (): RezaParamsMutable => {
	const [searchParams, setSearchParams] = useSearchParams({
		role: 'zmocnitel',
	});

	return {
		role: searchParams.get('role') === 'zmocnenec' ? 'zmocnenec' : 'zmocnitel',
		update: (value) => setSearchParams({ role: value.role }),
	};
};
